import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getProfileKyc = createAsyncThunk(
  "getProfileKyc/getProfileKyc",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("profileWithKYC");
      return response.data;
    } catch (error) {
      console.log(error, "error")
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const getProfileKycSlice = createSlice({
  name: "getProfileKyc",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfileKyc.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfileKyc.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getProfileKyc.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getProfileKycSlice.reducer;
